import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper";
import { BsPlayCircle } from "react-icons/bs";

// Import Swiper styles
import 'swiper/css';
import '../styles/slider.css'
import 'swiper/css/navigation'

const MySlider = ({ data, text }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        data.map((d, index) => {
            if (index === data.length - 1) {
                setLoaded(true);
            }
        })
    }, []);

    const mob = typeof window !== "undefined" ? window.innerWidth < 1000 ? true : false : false;
    const numSlides = mob ? 3 : 6;

    const SlideDiv = ({ d }) => {
        return <div className="slider-item" >
            <img src={mob ? d.poster : d.banner} alt={d.name} />
            {mob ? null : <div className="slide-data-icons">
                <BsPlayCircle />
            </div>}
        </div>
    }

    return (
        <div className="slider-overall">
            <div className="index-category-text" >&nbsp;<span> {loaded && text} </span></div>
            <Swiper navigation={!mob}
                modules={[Navigation]}
                spaceBetween={10}
                slidesPerView={numSlides}
                slidesPerGroup={3}
            >
                {
                    data.map((d, index) => {
                        return <SwiperSlide>
                            <SlideDiv d={d} />
                        </SwiperSlide>
                    })
                }
                {
                    data.map((d, index) => {
                        return <SwiperSlide>
                            <SlideDiv d={d} />
                        </SwiperSlide>
                    })
                }
                {
                    data.map((d, index) => {
                        return <SwiperSlide>
                            <SlideDiv d={d} />
                        </SwiperSlide>
                    })
                }
            </Swiper>
            <br />
        </div>
    );
};

export default MySlider